const policiesindex = r => require.ensure([], () => r(require('@/page/Policies/policiesindex')), 'policiesindex');
const policieskeepalive = r => require.ensure([], () => r(require('@/page/Policies/policieskeepalive')), 'policieskeepalive');

const policiesindexRouter = {
  path: '',
  component: policieskeepalive,
  meta: {
    icon: 'propertyAreaMge',
    right: [],
    isShowMenu: true,
    keepAlive:false
  },
  name: '政策法规与常见问题',
  children: [{
    path: '/policiesindex',
    component: policiesindex,
    name: '政策法规与常见问题',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:false,
    },
  }
  ]
};

export default policiesindexRouter;
